import { render, staticRenderFns } from "./PwaAward.vue?vue&type=template&id=598dd636&scoped=true&"
import script from "./PwaAward.vue?vue&type=script&lang=js&"
export * from "./PwaAward.vue?vue&type=script&lang=js&"
import style0 from "./PwaAward.vue?vue&type=style&index=0&id=598dd636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598dd636",
  null
  
)

export default component.exports